import FormData from "form-data";
import { apiCall } from ".";

export const getMessageList = (params = {}) => {
  return apiCall(true).get("/messages", { params });
};

export const getMessageThread = (groupKey: string, params = {}) => {
  // if (!groupKey) throw new Error("No group key was provided");
  return apiCall(true).get(`/messages/${groupKey}`, { params });
};

export const postMessageApi = (payload: FormData, headers: {}) => {
  return apiCall(true).post("/messages", payload, { headers });
};
